import {PostVoiceTranscriptionTermsAcceptParams} from 'domain/usecases/others/voice-transcription/post-voice-transcription-terms-accept';
import {makePostVoiceTranscriptionTermsAccept} from 'main/factories/usecases/others/voice-transcription/post-voice-transcription-terms-accept';

export const postVoiceTranscriptionTermsAccept = async ({
	Origem,
}: PostVoiceTranscriptionTermsAcceptParams) =>
	makePostVoiceTranscriptionTermsAccept().post({Origem});
